import React, { Component } from "react";
import { connect } from "react-redux";
import { loginAction } from "../../../redux/actions/auth";
import { Form, Input, Button, Row, Col, Divider } from "antd";
import { Redirect } from "react-router-dom";
import styles from "./login.module.css";
// import kfWx from "../../../assets/images/kf_wx.jpg";
// import logo1 from "../../../assets/images/logo1.png";

// 这是后台登录页面
class LoginPage extends Component {
  handleLogin = async ({ username, password }) => {
    // console.log('handleLogin', this.props);
    this.props.loginAction({ username, password });
  };

  //提交表单且数据验证成功后回调事件
  onFinish = (values) => {
    // console.log('Success:', values);
    const { username, password } = values;
    this.handleLogin({ username, password });
  };

  render() {
    // console.log('LoginPage', this.props);
    let { userInfo } = this.props;
    //如果用户已经是登录状态，自动跳转到home页面
    if (userInfo && userInfo.token && userInfo.id) {
      return <Redirect to="/home" />;
    }
    //未登录显示登录页面
    return (
      <>
        <Row>
          <Col
            span={12}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              // backgroundColor: "green",
            }}
          >
            <div>
              <h2>更新日志</h2>
              <div
                style={{
                  padding: "20px 20px",
                  width: "600px",
                  height: "400px",
                  overflowY: "auto",
                  // backgroundColor: "red",
                  border: "1px solid #eee",
                }}
              >
                <div>
                  <h3>v0.0.1</h3>
                  <ul>
                    <li>码头预约监控</li>
                  </ul>
                </div>
                <Divider />
              </div>
            </div>
          </Col>
          <Col span={2}></Col>
          <Col span={8}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                // marginTop: "30px",
                height: "100vh",
              }}
            >
              <div>
                {/* <img style={{ width: "200px" }} src={kfWx} alt="客服微信" /> */}
              </div>
              <div className={styles.loginForm}>
                <div className={styles.title}>
                  <span>Auto Security Monitoring Transport APPT</span>
                </div>
                <Form
                  name="basic"
                  labelCol={{
                    span: 4,
                  }}
                  wrapperCol={{
                    span: 18,
                  }}
                  onFinish={this.onFinish}
                  autoComplete="off"
                >
                  <Form.Item
                    label="用户名"
                    name="username"
                    rules={[
                      {
                        required: true,
                        message: "请输入用户名!",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    label="密码"
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "请输入密码!",
                      },
                    ]}
                  >
                    <Input.Password />
                  </Form.Item>

                  <Form.Item
                    wrapperCol={{
                      offset: 4,
                      span: 18,
                    }}
                  >
                    <Button block size="large" type="primary" htmlType="submit">
                      登录
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </>
    );
  }
}

export default connect((state) => ({ userInfo: state.auth.userInfo }), {
  loginAction,
})(LoginPage);
